// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmPhoneResponseDTOAPIModel
 */
export interface ConfirmPhoneResponseDTOAPIModel {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPhoneResponseDTOAPIModel
     */
    phone: string;
}

export function ConfirmPhoneResponseDTOAPIModelFromJSON(json: any): ConfirmPhoneResponseDTOAPIModel {
    return ConfirmPhoneResponseDTOAPIModelFromJSONTyped(json, false);
}

export function ConfirmPhoneResponseDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmPhoneResponseDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function ConfirmPhoneResponseDTOAPIModelToJSON(value?: ConfirmPhoneResponseDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
    };
}


